
import React, { useEffect, useState } from "react"
import axios from "axios"
import Cookies from "js-cookie"
import { useNavigate } from "react-router-dom"

import {
  filterVisibleFoods,
  formatRemainingTime,
  formatStockQuantity,
  getFoodImageUrl,
  getFoodStatusLabel,
  isOrderable
} from "../utils/foodAvailability"

const API = "https://food-backend-9733.onrender.com"

const WeeklyItems = () => {
  const [foods, setFoods] = useState([])
  const [loading, setLoading] = useState(true)
  const [cartItems, setCartItems] = useState({})

  const navigate = useNavigate()

  const getToken = () => {
    try {
      return JSON.parse(Cookies.get("logincrd") || "{}")?.token
    } catch {
      return null
    }
  }

  const loadCart = async () => {
    const token = getToken()
    if (!token) return

    try {
      const res = await axios.get(`${API}/cart`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })

      const obj = {}

      res.data.forEach(item => {
        const key = `${item.food_id}_${item.selected_size || "100g"}`
        obj[key] = item.quantity
      })

      setCartItems(obj)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    axios.get(`${API}/foods`)
      .then(res => {
        const filtered = filterVisibleFoods(res.data).filter(
          item =>
            String(item.category || "")
              .trim()
              .toLowerCase() === "weekly"
        )

        setFoods(filtered)
        setLoading(false)
      })
      .catch(err => {
        console.log(err)
        setLoading(false)
      })
  }, [])

  useEffect(() => {
    loadCart()
  }, [])

  const openProductForAvailability = foodId => {
    navigate(`/food/${foodId}?checkAvailability=1`)
  }

  const getTitleParts = name => {
    const words = String(name || "").trim().split(" ")

    return {
      first: words[0] || "",
      rest: words.slice(1).join(" ") || ""
    }
  }

  if (loading) {
    return (
      <div className="forty-page weekly-page">
        <div className="forty-empty">
          Loading Weekly Foods...
        </div>
      </div>
    )
  }

  return (
    <div className="forty-page weekly-page">
      <div className="forty-hero weekly-hero">
        <button
          className="forty-back-btn"
          onClick={() => navigate("/")}
        >
          Back
        </button>

        <span className="limited-hero-kicker">
          Weekly Fresh Batch
        </span>

        <h1>Weekly Special Foods</h1>

        <p>
          Fresh homemade items available for one week after upload.
          Order while the weekly batch is active.
        </p>
      </div>

      {foods.length === 0 && (
        <div className="forty-empty">
          <h2>Coming Soon</h2>
          <p>
            We are preparing delicious homemade items for our weekly
            special batch. Please check back soon!
          </p>
        </div>
      )}

      {foods.length > 0 && (
        <div className="forty-grid">
          {foods.map(item => {
            const cartKey = `${item.id}_100g`
            const orderable = isOrderable(item)
            const timerText = formatRemainingTime(item)
            const title = getTitleParts(item.name)

            return (
              <div
                key={item.id}
                className="limited-food-card"
              >
                <div
                  className={
                    orderable
                      ? "forty-card premium-48-card weekly-premium-card"
                      : "forty-card premium-48-card weekly-premium-card food-card-disabled"
                  }
                  onClick={() => navigate(`/food/${item.id}`)}
                >
                  <img
                    src={getFoodImageUrl(item, API)}
                    alt={item.name}
                    onError={e => {
                      e.currentTarget.src = "/logo192.png"
                    }}
                  />

                  <div className="premium-48-ribbon weekly-ribbon">
                    <span className="premium-48-text">
                      <b>7</b>
                      <small>DAYS</small>
                      <em>WEEKLY</em>
                    </span>
                  </div>

                  <div className="premium-48-price">
                    <h3>₹{item.price}</h3>
                    <p>— WEEKLY SPECIAL —</p>
                  </div>

                  <div className="premium-48-content">
                    <h2 className="premium-48-title">
                      <span>{title.first}</span>

                      {title.rest && (
                        <b>{title.rest}</b>
                      )}
                    </h2>

                    <div className="premium-48-dotted-line"></div>

                    <div className="premium-48-info-row">
                      <div className="premium-48-info">
                        <div className="premium-48-clock">
                          <span></span>
                        </div>

                        <div>
                          <small>ENDS IN</small>
                          <strong>
                            {timerText || "EXPIRED"}
                          </strong>
                        </div>
                      </div>

                      <div className="premium-48-vertical-line"></div>

                      <div className="premium-48-info">
                        <div className="premium-48-stock-icon">
                          <span></span>
                        </div>

                        <div>
                          <small>ONLY</small>
                          <strong className="stock-green">
                            {orderable
                              ? formatStockQuantity(
                                  item,
                                  "g LEFT",
                                  "LIMITED STOCK"
                                )
                              : getFoodStatusLabel(item)}
                          </strong>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <button
                  className="add-cart-full-btn premium-48-cart-btn"
                  onClick={() => openProductForAvailability(item.id)}
                  disabled={!orderable}
                >
                  {!orderable
                    ? getFoodStatusLabel(item)
                    : cartItems[cartKey]
                      ? `Added ${cartItems[cartKey]} · Add More`
                      : "🛒 BUY NOW"}
                </button>
              </div>
            )
          })}
        </div>
      )}

      {Object.values(cartItems).reduce((a, b) => a + b, 0) > 0 && (
        <div className="floating-cart">
          <span>
            🛒 {Object.values(cartItems).reduce((a, b) => a + b, 0)}
          </span>

          <button onClick={() => navigate("/cart")}>
            Go To Cart
          </button>
        </div>
      )}
    </div>
  )
}

export default WeeklyItems
